exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MediaList-local__list--3Inii {\n  position: relative;\n  margin: 0 -3px; }\n  .MediaList-local__list--3Inii li {\n    padding: 0 3px;\n    margin-bottom: 6px; }\n  .MediaList-local__list--3Inii .MediaList-local__media--38oYO {\n    height: 8.75rem;\n    width: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    -webkit-box-shadow: 0px 4px 4px rgba(41, 57, 77, 0.3);\n            box-shadow: 0px 4px 4px rgba(41, 57, 77, 0.3);\n    border-radius: 5px; }\n    .MediaList-local__list--3Inii .MediaList-local__media--38oYO.MediaList-local__forAlbum--2muj0 {\n      height: 2.875rem;\n      border-radius: 2px; }\n", ""]);

// exports
exports.locals = {
	"list": "MediaList-local__list--3Inii",
	"media": "MediaList-local__media--38oYO",
	"forAlbum": "MediaList-local__forAlbum--2muj0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/MediaList/MediaList.local.scss
// module id = 428
// module chunks = 0